var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages, clearSelectedFiles, uploadSelectedFiles } from './messages';
/**
 * @hidden
 */
var UploadActionButtons = /** @class */ (function (_super) {
    __extends(UploadActionButtons, _super);
    function UploadActionButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClearClick = function () {
            if (_this.props.disabled) {
                return;
            }
            if (_this.props.onClear) {
                _this.props.onClear.call(undefined);
            }
        };
        _this.onUploadClick = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.props.onClick.call(undefined, _this.props.uploadButtonIndex);
            if (_this.props.onUpload) {
                _this.props.onUpload.call(undefined);
            }
        };
        return _this;
    }
    UploadActionButtons.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, navigationIndex = _a.navigationIndex, clearButtonIndex = _a.clearButtonIndex, uploadButtonIndex = _a.uploadButtonIndex;
        if (navigationIndex !== prevProps.navigationIndex) {
            if (navigationIndex === clearButtonIndex && this._clearElement) {
                this._clearElement.focus();
            }
            if (navigationIndex === uploadButtonIndex && this._uploadElement) {
                this._uploadElement.focus();
            }
        }
    };
    UploadActionButtons.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, navigationIndex = _a.navigationIndex, clearButtonIndex = _a.clearButtonIndex, uploadButtonIndex = _a.uploadButtonIndex, actionsLayout = _a.actionsLayout;
        var localizationService = provideLocalizationService(this);
        var wrapperClasses = classNames('k-actions', 'k-hstack', {
            'k-justify-content-start': actionsLayout === 'start',
            'k-justify-content-center': actionsLayout === 'center',
            'k-justify-content-end': actionsLayout === 'end',
            'k-justify-content-stretch': actionsLayout === 'stretched'
        });
        var clearButtonClasses = classNames('k-button', 'k-clear-selected', disabled ? 'k-state-disabled' : '', navigationIndex === clearButtonIndex ? 'k-state-focused' : '');
        var uploadButtonClasses = classNames('k-button', 'k-primary', 'k-upload-selected', disabled ? 'k-state-disabled' : '', navigationIndex === uploadButtonIndex ? 'k-state-focused' : '');
        return (React.createElement("div", { className: wrapperClasses },
            React.createElement("button", { ref: function (ref) { return _this._clearElement = ref; }, type: 'button', className: clearButtonClasses, tabIndex: -1, onClick: this.onClearClick }, localizationService
                .toLanguageString(clearSelectedFiles, messages[clearSelectedFiles])),
            React.createElement("button", { ref: function (ref) { return _this._uploadElement = ref; }, type: 'button', className: uploadButtonClasses, tabIndex: -1, onClick: this.onUploadClick }, localizationService
                .toLanguageString(uploadSelectedFiles, messages[uploadSelectedFiles]))));
    };
    return UploadActionButtons;
}(React.Component));
export { UploadActionButtons };
registerForLocalization(UploadActionButtons);
